import gql from 'graphql-tag';
import User from '../../../entity/user';

const signup = gql`
  mutation signup(
    $token: String!
    $signupUserInput: UserSignupUserInput!
  ) {
    signup(
      token: $token
      userInput: $signupUserInput
    ) {
      ${User.fragmentsFields()}
    }
  }
`;

export default signup;
